export default "__VITE_ASSET__CHHzxzCS__"